import React from 'react';
import { Modal, Button } from 'antd';
import { 
  CheckCircleOutlined, 
  CloseCircleOutlined, 
  ExclamationCircleOutlined, 
  InfoCircleOutlined,
  SecurityScanOutlined,
  LockOutlined
} from '@ant-design/icons';

const CustomAlert = ({ 
  visible, 
  onClose, 
  title = '提示', 
  message, 
  type = 'info', // 'success', 'error', 'warning', 'info'
  confirmText = '确定',
  showCancel = false,
  cancelText = '取消',
  onConfirm
}) => {
  const getIcon = () => {
    const iconStyle = {
      fontSize: '48px',
      marginBottom: '16px',
      display: 'block'
    };

    switch (type) {
      case 'success':
        return <CheckCircleOutlined style={{ ...iconStyle, color: '#52c41a' }} />;
      case 'error':
        return <CloseCircleOutlined style={{ ...iconStyle, color: '#ff4d4f' }} />;
      case 'warning':
        return <ExclamationCircleOutlined style={{ ...iconStyle, color: '#faad14' }} />;
      case 'security':
        return <SecurityScanOutlined style={{ ...iconStyle, color: '#722ed1' }} />;
      case 'auth':
        return <LockOutlined style={{ ...iconStyle, color: '#eb2f96' }} />;
      default:
        return <InfoCircleOutlined style={{ ...iconStyle, color: '#1890ff' }} />;
    }
  };

  const getTitleColor = () => {
    switch (type) {
      case 'success':
        return '#52c41a';
      case 'error':
        return '#ff4d4f';
      case 'warning':
        return '#faad14';
      case 'security':
        return '#722ed1';
      case 'auth':
        return '#eb2f96';
      default:
        return '#1890ff';
    }
  };

  const getBackgroundGradient = () => {
    switch (type) {
      case 'success':
        return 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)';
      case 'error':
        return 'linear-gradient(135deg, #fff2f0 0%, #ffccc7 100%)';
      case 'warning':
        return 'linear-gradient(135deg, #fffbe6 0%, #fff1b8 100%)';
      case 'security':
        return 'linear-gradient(135deg, #f9f0ff 0%, #efdbff 100%)';
      case 'auth':
        return 'linear-gradient(135deg, #fff0f6 0%, #ffd6e7 100%)';
      default:
        return 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)';
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={420}
      centered
      closable={false}
      maskClosable={false}
      style={{
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)'
      }}
      styles={{
        body: {
          padding: '0',
          background: getBackgroundGradient(),
          borderRadius: '16px',
          position: 'relative',
          overflow: 'hidden'
        }
      }}
    >
      {/* 装饰性背景元素 */}
      <div style={{
        position: 'absolute',
        top: '-20px',
        right: '-20px',
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.1)',
        zIndex: 0
      }} />
      <div style={{
        position: 'absolute',
        bottom: '-30px',
        left: '-30px',
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.05)',
        zIndex: 0
      }} />
      
      <div style={{ 
        position: 'relative', 
        zIndex: 1,
        padding: '32px 24px',
        textAlign: 'center'
      }}>
        {getIcon()}
        
        <div style={{ 
          fontSize: '20px', 
          fontWeight: '700', 
          color: getTitleColor(),
          marginBottom: '12px',
          letterSpacing: '0.5px'
        }}>
          {title}
        </div>
        
        <div style={{ 
          fontSize: '15px', 
          color: '#666',
          lineHeight: '1.6',
          marginBottom: '32px',
          maxWidth: '320px',
          margin: '0 auto 32px auto'
        }}>
          {message}
        </div>
        
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          gap: '16px',
          flexWrap: 'wrap'
        }}>
          {showCancel && (
            <Button 
              onClick={onClose}
              size="large"
              style={{
                borderRadius: '8px',
                height: '44px',
                padding: '0 24px',
                border: '2px solid #d9d9d9',
                color: '#666',
                fontWeight: '500',
                background: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderColor = '#999';
                e.target.style.color = '#333';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = '#d9d9d9';
                e.target.style.color = '#666';
              }}
            >
              {cancelText}
            </Button>
          )}
          <Button 
            type="primary" 
            onClick={handleConfirm}
            size="large"
            style={{
              borderRadius: '8px',
              height: '44px',
              padding: '0 24px',
              background: getTitleColor(),
              borderColor: getTitleColor(),
              fontWeight: '600',
              boxShadow: `0 4px 12px ${getTitleColor()}40`,
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = `0 6px 16px ${getTitleColor()}60`;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = `0 4px 12px ${getTitleColor()}40`;
            }}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomAlert; 